
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        <div className="bg-gray-900 rounded-2xl border border-gray-800 p-8 lg:p-12">
          <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Privacy Policy
          </h1>
          
          <div className="space-y-8 text-gray-300 leading-relaxed">
            <div>
              <p className="text-sm text-gray-400 mb-4">Effective Date: 01-01-2025</p>
              <p className="text-sm text-gray-400 mb-6">Company: Prismatics AI</p>
              <p>
                At Prismatics AI, we respect your privacy. This policy explains how we handle your information.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Information We Collect</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>Details you provide (e.g., name, email, company).</li>
                <li>Basic usage data like IP, browser type, and pages visited.</li>
                <li>Cookies to improve site experience.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">How We Use It</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>To provide and improve our services.</li>
                <li>To respond to demo requests, inquiries, and support.</li>
                <li>To send updates (only with your consent).</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Sharing</h2>
              <p>
                We do not sell your data. Limited sharing may occur with trusted service providers (e.g., hosting, analytics) to run our site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Security</h2>
              <p>
                We take reasonable steps to protect your data, but no online method is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Your Rights</h2>
              <p>
                You can request access, updates, or deletion of your data by emailing us.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Changes</h2>
              <p>
                We may update this policy occasionally and post the new version here.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">Contact</h2>
              <p>
                📧 <a href="mailto:reach@prismatics-ai.com" className="text-blue-400 hover:text-blue-300 cursor-pointer">reach@prismatics-ai.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
